import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueGtag from "vue-gtag";
import Ads from "vue-google-adsense";
import VueCarousel from 'vue-carousel';

Vue.config.devtools = true;
Vue.config.productionTip = false

Vue.use(VueCarousel);

Vue.use(VueGtag, {
  config: { id: "G-X0DBQ3TGXV" }
});

Vue.use(require("vue-script2"));
Vue.use(Ads.Adsense);
Vue.use(Ads.InArticleAdsense);
Vue.use(Ads.InFeedAdsense);

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
